import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CompassCalibrationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"compass_calibration"}/>
}
